import { useEffect, useState } from 'react';
import { wikiLog, WikiLogEntry } from '../api/wiki';

export function LogView({ pid }: { pid: string }) {
  const [log, setLog] = useState<WikiLogEntry[]>([]);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    void wikiLog(pid, { limit: 200 })
      .then((r) => {
        if (!cancelled) setLog(r.log);
      })
      .catch((e) => {
        if (!cancelled) setError((e as Error).message);
      });
    return () => {
      cancelled = true;
    };
  }, [pid]);

  if (error)
    return (
      <div style={{ padding: 24 }}>
        <a href={`#/wiki/p/${encodeURIComponent(pid)}`}>← Project</a>
        <div className="banner banner-warning">{error}</div>
      </div>
    );
  return (
    <div style={{ padding: 24, maxWidth: 900, margin: '0 auto' }}>
      <a href={`#/wiki/p/${encodeURIComponent(pid)}`}>← Project</a>
      <h2 style={{ marginTop: 8 }}>Activity log</h2>
      {log.length === 0 ? (
        <div className="muted">No activity yet.</div>
      ) : (
        <table style={{ width: '100%', fontSize: 14 }}>
          <thead>
            <tr>
              <th align="left">Time</th>
              <th align="left">Kind</th>
              <th align="left">Summary</th>
            </tr>
          </thead>
          <tbody>
            {log.map((e) => (
              <tr key={e.id}>
                <td className="muted small">
                  {new Date(e.ts).toLocaleString()}
                </td>
                <td>
                  <code>{e.kind}</code>
                </td>
                <td>{e.summary}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
